import React, { Component } from "react";

//Import CSS
import "./confirmed.css";

//Import internal components
import AppContext from "../../appContext";
import CustomButton from "../../components/buttons/button";
import OrderSummaryPDF from "./order-summary-pdf";
import IconConfirmed from "./confirmed-icon";
import OrderConfirmedHeader from "./OrderConfirmedHeader";
import OrderConfirmedOrderInfo from "./OrderConfirmedOrderInfo";

//Import external components
import { Redirect } from "react-router";
import Swal from "sweetalert2";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { Gift } from "react-bootstrap-icons";
import PDFOrder from "../pdf-order/pdf-order";
import MarcaPropriaAlert from "../../shared/components/marca-propria/marca-propria-alert";
import { getPromocoesMarcaPropria } from "../../Functions/gestao-promocao-laboratorio/get-promocoes";

//Import images

class Confirmed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectL: false,
      redirectWO: false,
      confirmed: false,
      pedido: "",
      valor: "",
      prazo: "",
      observacao: "",
      newOrder: "",
      newOrderPromo: "",
      redeOticas: "",
      redirectGerarCupom: false,
      promotionName: "",
    };

    Confirmed.contextType = AppContext;

    if (sessionStorage.getItem("token") !== null) {
      var token = sessionStorage.getItem("token");

      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );

      var jwt = JSON.parse(jsonPayload);

      const role = jwt.modulos.find(element => element === "Pedidos");

      var papel = jwt.papel;

      this.state = { papel: jwt.papel };

      if (!role) {
        this.state = { redirect: true };
      }
    } else {
      this.state = { redirectL: true };
    }
    if (this.props.location.state === undefined && this.state.confirmed === false) {
      this.state = { redirectWO: true };
    }
  }

  componentDidMount() {
    if (this.props.location.state !== undefined) {
      this.setState({
        pedido: this.props.location.state.pedido,
        prazo: this.props.location.state.prazo,
        observacao: this.props.location.state.observacao,
        valor: this.props.location.state.valor,
        newOrder: this.props.location.state.newOrder,
        newOrderPromo: this.props.location.state.newOrderPromo,
        redeOticas: this.props.location.state.redeOticas,
        promotionName: this.props.location.state.marcaPropriaNome || "",
      });

      this.consultarPromocoesMarcaPropria();
    }
  }

  consultarPromocoesMarcaPropria = () => {
    const { pedido, lab, isLabOG, marcaPropriaNome, promo_code } = this.props.location.state;

    if (isLabOG || marcaPropriaNome || promo_code || !pedido || !lab) {
      return;
    }

    getPromocoesMarcaPropria(pedido, lab).then(promocoes => {
      if (promocoes.length > 0) {
        this.setState({ promocoesMarcaPropria: promocoes });
      }
    });
  };

  newOrder = e => {
    e.preventDefault();
    this.setState({ redirectPromo: true });
  };

  newOrderMarcaPropria = e => {
    e.preventDefault();
    this.setState({ redirectMarcaPropria: true });
  };
  redirectGerarCupom = e => {
    e.preventDefault();
    this.setState({ redirectGerarCupom: true });
  };

  render() {
    const parametros = this.props.location.state.parametros;
    const { pedido, prazo, valor, newOrder, newOrderPromo, redeOticas, observacao } = this.props.location.state;
    const temPromocoesMarcaPropria = (this.state.promocoesMarcaPropria || []).length > 0;

    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }
    if (this.state.redirectL) {
      return <Redirect to="/" />;
    }
    if (this.state.redirectWO) {
      return <Redirect to="/web-ordering" />;
    }
    if (this.state.redirectPromo) {
      return (
        <Redirect
          to={{
            pathname: "/order",
            state: {
              name: this.props.location.state.labName,
              lab: this.props.location.state.lab,
              dados_empresa_faturamento: this.props.location.state.dados_empresa_faturamento,
              dados_empresa_faturamento_cnpj: this.props.location.state.dados_empresa_faturamento_cnpj,
              promo: this.props.location.state.promo_code ? true : false,
              promo_code: this.props.location.state.promo_code,
              promo_proximo_par: parseInt(this.props.location.state.promo_n_par) + 1,
              promo_total_pares: this.props.location.state.promo_total_pares,
              IsCor_AR: this.props.location.state.IsCor_AR,
              IsGrowmocao: this.props.location.state.IsGrowmocao,
              IsPacto: this.props.location.state.IsPacto,
              isLabOG: this.props.location.state.isLabOG,
              corteRemoto: this.props.location.state.hasCorteRemoto,
              detailOrder: this.props.location.state.detailOrder,
              colorirNaOtica: this.props.location.state.colorirNaOtica,
              CorteMontagemObrigatorio: this.props.location.state.CorteMontagemObrigatorio,
              ArmacaoUsadaNova: this.props.location.state.ArmacaoUsadaNova || false,
              // dados_nome_cliente: this.props.location.state.costumer.name,
              // dados_cpf_cliente: this.props.location.state.costumer.cpf,
              // dados_crm_medico: this.props.location.state.costumer.doctorCRM,
              logo: this.props.location.state.logo,
              rastreabilidade: {
                conta: this.props.location.state.rastreabilidade.conta,
                has: this.props.location.state.rastreabilidade.has,
                valid: this.props.location.state.rastreabilidade.valid,
              },
            },
          }}
        />
      );
    }
    if (this.state.redirectMarcaPropria) {
      return (
        <Redirect
          to={{
            pathname: "/order",
            state: {
              name: this.props.location.state.labName,
              lab: this.props.location.state.lab,
              dados_empresa_faturamento: this.props.location.state.dados_empresa_faturamento,
              dados_empresa_faturamento_cnpj: this.props.location.state.dados_empresa_faturamento_cnpj,
              IsCor_AR: this.props.location.state.IsCor_AR,
              IsGrowmocao: this.props.location.state.IsGrowmocao,
              IsPacto: this.props.location.state.IsPacto,
              isLabOG: this.props.location.state.isLabOG,
              corteRemoto: this.props.location.state.hasCorteRemoto,
              detailOrder: this.props.location.state.detailOrder,
              colorirNaOtica: this.props.location.state.colorirNaOtica,
              CorteMontagemObrigatorio: this.props.location.state.CorteMontagemObrigatorio,
              ArmacaoUsadaNova: this.props.location.state.ArmacaoUsadaNova || false,
              logo: this.props.location.state.logo,
              rastreabilidade: {
                conta: this.props.location.state.rastreabilidade.conta,
                has: this.props.location.state.rastreabilidade.has,
                valid: this.props.location.state.rastreabilidade.valid,
              },
              marcaPropria: {
                pedidoOrigem: this.props.location.state.pedido,
                promocoes: this.state.promocoesMarcaPropria || [],
              },
            },
          }}
        />
      );
    }
    if (this.state.redirectGerarCupom) {
      return <Redirect to="/gerar-cupons" />;
    }

    return (
      <div>
        <main className="x-order-confirmed__main" id="main-body">
          <IconConfirmed />

          <div className="x-order-confirmed__container1">
            <OrderConfirmedHeader
              isLabOG={this.props.location.state.isLabOG}
              promoCode={this.props.location.state.promo_code}
              labName={this.props.location.state.labName}
              dadosEmpresaFaturamento={this.props.location.state.dados_empresa_faturamento}
              userSessionNomeEmpresa={this.context.userSession.nomeEmpresa}
              userSessionPapelCategoria={this.context.userSession.papelCategoria}
              dadosEmpresaFaturamentoCnpj={this.props.location.state.dados_empresa_faturamento_cnpj}
            />

            <OrderConfirmedOrderInfo
              promoCode={this.props.location.state.promo_code}
              isLabOG={this.props.location.state.isLabOG}
              labName={this.props.location.state.labName}
              pedido={pedido}
              prazo={prazo}
              observacao={observacao}
              promocaoNome={this.state.promotionName}
            />

            {this.props.location.state.detailOrder ? (
              <PDFOrder
                label="Imprimir Pedido"
                btn_class="pdf-pedido__summary--print"
                icon={false}
                prazo={prazo}
                laboratorio={this.props.location.state.lab}
                otica={this.props.location.state.dados_empresa_faturamento_cnpj}
                pedido_laboratotio={pedido}
                laboratorio_nome={this.props.location.state.labName}
                redeOticas={this.props.location.state.redeOticas}
                rastreabilidade={this.props.location.state.rastreabilidade.valid}
                isLabOG={this.props.location.state.isLabOG}
                isPedidoPromocional={this.props.location.state.isPedidoPromocional}
                local={"order-confirmed"}
                promotionName={this.state.promotionName || ""}
                pedidoOrigemPromocao={this.props.location.state.marcaPropriaPedidoOrigem || ""}
              />
            ) : (
              <>
                <ReactToPrint
                  documentTitle={`Essilor Conecta - Pedido ${pedido}`}
                  trigger={() => {
                    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                    // to the root node of the returned component as it will be overwritten.
                    return <a id="btn-imprimir-pedido" className="pdf-pedido__summary--print">Imprimir Pedido</a>;
                  }}
                  content={() => this.componentRef}
                />

                <div style={{ display: "none" }}>
                  <OrderSummaryPDF
                    ref={el => (this.componentRef = el)}
                    order={this.props.location.state.orderSummary}
                    pedido={pedido}
                    prazo={prazo}
                    isLabOG={this.props.location.state.isLabOG}
                    isPedidoPromocional={this.props.location.state.isPedidoPromocional}
                    parametros={parametros}
                    promotionName={this.state.promotionName || ""}
                    pedidoOrigemPromocao={this.props.location.state.marcaPropriaPedidoOrigem || ""}
                  />
                </div>
              </>
            )}

            {temPromocoesMarcaPropria && (
              <MarcaPropriaAlert id="alert-marca-propria-elegivel">
                <Gift size={16} />
                <br />
                Seu pedido é elegível para realizar um novo <strong>pedido promocional</strong> do laboratório{" "}
                <strong>{this.props.location.state.labName}</strong>.
              </MarcaPropriaAlert>
            )}

            <div className="button-mobile-only order-confirmed-button" style={{ display: 'flex', justifyContent: 'center' }}>
              {this.props.location.state.promo_n_par < this.props.location.state.promo_total_pares ? (
                <>
                  <CustomButton
                    id="btn-inserir-proximo-par"
                    label={`Inserir ${parseInt(this.props.location.state.promo_n_par) + 1}° par`}
                    width="16rem"
                    icon_arrow_right
                    orange_button
                    onClick={this.newOrder}
                  />
                </>
              ) : this.props.location.state.promo_code ? (
                <>
                  <CustomButton
                    id="btn-gerar-novo-cupom"
                    label="Gerar Novo Cupom"
                    width="13.125rem"
                    icon_arrow_right
                    orange_button
                    onClick={this.redirectGerarCupom}
                  />
                </>
              ) : temPromocoesMarcaPropria ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <CustomButton
                    id="btn-fazer-pedido-promocional"
                    label="Fazer pedido promocional"
                    width="20rem"
                    onClick={this.newOrderMarcaPropria}
                  />
                  <button
                    id="btn-fazer-pedido-sem-promocao"
                    type="button"
                    className="x-order-confirmed__btn-sem-promocao"
                    onClick={() => {
                      window.location = newOrder;
                    }}>
                    Fazer pedido sem promoção
                  </button>
                </div>
              ) : (
                <>
                  <CustomButton
                    id="btn-novo-pedido"
                    label="Fazer novo pedido"
                    width="13.125rem"
                    icon_arrow_right
                    orange_button
                    onClick={() => {
                      window.location = newOrder;
                    }}
                  />
                </>
              )}
            </div>

            {/* <a className="x-ordr-confirmed__link" target="_blank" href="/">Copiar Pedido</a> */}
          </div>
        </main>
      </div>
    );
  }
}

export default Confirmed;
